const setResumeLanguages = (languages) => ({
    type: 'SET_RESUME_LANGUAGES',
    languages,
});

export default setResumeLanguages;
